import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material"
import { useEffect } from "react"
import { DashboardInvoice } from "layouts/dashboard/DashboardInvoice.tsx"
import { MainPageContentContainer } from "components/MainPageContentContainer.tsx"
import { Box } from "@mui/system"
import { SelectChangeEvent } from "@mui/material/Select"
import { useState } from "react"
import { DashboardInfo } from "layouts/dashboard/DasboardCardInfo.tsx"
import { DashboardGraph } from "layouts/dashboard/DashboardGraph.tsx"
import { DashboardCardInfo } from "components/dashboard/cardInfo.tsx"
import { useMmsService } from "services/mms/context/MmsServiceContext.tsx"

const heightContentPage = "calc(100vh - 80px - 64px - 60px - 1.5rem)"
export const BoardPage = () => {
    const defaultStartDate = new Date(
        new Date().setMonth(new Date().getMonth() - 12)
    ).toString()
    const [selectValue, setSelectValue] = useState<string>("12")
    const [startDate, setStartDate] = useState<string>(defaultStartDate)
    const {
        rfidService,
        /*    driversService,
         */
    } = useMmsService()
    /*
        const { useGetAllActiveDrivers } = driversService
    */

    /*
        const {
            sendRequest: fetchDriversActive,
            isLoading: driversActiveLoading,
        } = useGetAllActiveDrivers()
    */
    const {
        data: rfidActive,
        sendRequest: fetRfidActive,
        isLoading: rfidActiveLoading,
    } = rfidService.useGetListRfidActiveCards()
    const {
        data: rfidUnactive,
        sendRequest: fetRfidUnactive,
        isLoading: rfidUnactiveLoading,
    } = rfidService.useGetListRfidUnactiveCards()

    useEffect(() => {
        fetRfidActive()
        fetRfidUnactive()
        /*
                fetchDriversActive()
        */
    }, [])

    useEffect(() => {
        /*
                console.log("driversActive", driversActive)
        */
        console.log("rfidActive", rfidActive)
        console.log("rfidUnactive", rfidUnactive)
    }, [rfidActive, rfidUnactive])

    const handleChange = (event: SelectChangeEvent) => {
        const nbOfMonth = event.target.value as unknown as number
        setStartDate(
            new Date(
                new Date().setMonth(new Date().getMonth() - nbOfMonth)
            ).toString()
        )
        setSelectValue(event.target.value as string)
    }

    return (
        <Grid container columnSpacing={{ md: 3, xl: 15 }}>
            <Grid
                item
                md={9}
                sx={{
                    height: heightContentPage,
                    display: "flex",
                    flexDirection: "row",
                }}
            >
                <MainPageContentContainer
                    sx={{
                        bgcolor: "grey.100",
                        height: "100%",
                        width: "20%",
                        borderTopRightRadius: "0px",
                        borderBottomRightRadius: "0px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1rem",
                        }}
                    >
                        {/*
                        {!driversActiveLoading && (
                            <DashboardCardInfo
                                background={false}
                                title={"Nombre de conducteurs actifs"}
                                value={
                                    driversActive
                                        ? driversActive.toString()
                                        : undefined
                                }
                            />
                        )}
*/}
                        {!rfidActiveLoading && (
                            <DashboardCardInfo
                                background={false}
                                title={"Nombre de carte actives"}
                                value={
                                    rfidActive
                                        ? rfidActive.toString()
                                        : undefined
                                }
                            />
                        )}
                        {!rfidUnactiveLoading && (
                            <DashboardCardInfo
                                background={false}
                                title={"Nombre de carte inactives"}
                                value={
                                    rfidUnactive
                                        ? rfidUnactive.toString()
                                        : undefined
                                }
                            />
                        )}
                    </Box>
                </MainPageContentContainer>
                <MainPageContentContainer
                    sx={{
                        height: "100%",
                        width: "80%",
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.8rem",
                    }}
                >
                    <Box sx={{ width: "100%", height: "10%" }}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="demo-simple-select-label">
                                Période
                            </InputLabel>
                            <Select
                                sx={{ bgcolor: "grey.100" }}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectValue}
                                label="Période"
                                onChange={handleChange}
                            >
                                <MenuItem value={1}>Mois</MenuItem>
                                <MenuItem value={3}>Dernier trimestre</MenuItem>
                                <MenuItem value={12}>Dernière année</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Box
                        sx={{
                            width: "100%",
                            height: "90%",
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                        }}
                    >
                        <Box
                            sx={{
                                width: "50%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <DashboardInfo
                                key={startDate}
                                startDate={new Date(startDate)}
                                endDate={new Date()}
                            />
                        </Box>
                        <Box sx={{ height: "100%", width: "50%" }}>
                            <DashboardGraph
                                key={startDate}
                                startDate={startDate}
                                endDate={new Date().toString()}
                            />
                        </Box>
                    </Box>
                </MainPageContentContainer>
            </Grid>
            <Grid item md={3} sx={{ height: heightContentPage }}>
                <DashboardInvoice />
            </Grid>
        </Grid>
    )
}
